import {
  ActionArm,
  ActionDisarm,
  ActionGoto,
  MissionClear,
  MissionLoad,
  MissionResume,
  MissionStart,
  MissionUpload,
  ModeAuto,
  ModeHold,
  ModeRTL,
} from '@/define/commandSet/mavlink';

const commandGroups = [
  {
    name: 'Mode',
    commands: [ModeAuto, ModeHold, ModeRTL],
  },
  {
    name: 'Action',
    commands: [ActionArm, ActionDisarm, ActionGoto],
  },
  {
    name: 'Mission',
    commands: [MissionLoad, MissionUpload, MissionStart, MissionResume, MissionClear],
  },
];

export default commandGroups;
